import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionTargets, OEVersionFeatureAccess, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEThiemeTargetType as OEThiemeTargetType_, OEThiemeStartSelectionContent} from './oe-thieme-consts';

export const OEThiemeTargetType = OEThiemeTargetType_;

export const OEThiemeTargets = new OEVersionTargets(
    {
        [OEThiemeTargetType.anatomy]: [
// @ADD_TARGET_THIEME_OETARGET
            OETarget.thiemeCNS,
            OETarget.thiemeArm,
            OETarget.thiemeShoulderGirdle,
            OETarget.thiemeShoulderGirdleAnimation,
            OETarget.thiemeUpperArmElbow,
            OETarget.thiemeForearm,
            OETarget.thiemeHand,
            OETarget.thiemeLeg,
            OETarget.thiemeHip2,
            OETarget.thiemeThighKnee,
            OETarget.thiemeLowerLeg,
            OETarget.thiemeAnkleFoot,
            OETarget.thiemeTrunk,
            OETarget.thiemeNeckBack,
            OETarget.thiemeChestWall,
            OETarget.thiemeAbdominalWall,
            OETarget.thiemePelvis,
            OETarget.thiemeSpine
        ],
        [OEThiemeTargetType.head]: [
            OETarget.thiemeSkull,
            OETarget.thiemeHead,
            OETarget.thiemeCranialNerves,
            OETarget.thiemeEye2,
            OETarget.thiemeEyeAnimation,
            OETarget.humanEyeCornea,
            OETarget.thiemeEyeRetina,
            OETarget.thiemeEarMacro,
            OETarget.humanEarMicro,
            OETarget.thiemeEarInner,
            OETarget.thiemeLarynx,
            OETarget.thiemeLarynxAnimation,
        ],
        [OEThiemeTargetType.biology]: [
            OETarget.virusSarscov2,
        ]
    },
    {
        [OEThiemeTargetType.anatomy]: OETarget.thiemeHand,
        [OEThiemeTargetType.head]: OETarget.thiemeSkull,
        [OEThiemeTargetType.biology]: OETarget.virusSarscov2,
    },
    {
        [OEThiemeTargetType.head]: OETarget.thiemeSkull
    }
);

export const OEThiemeFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
            biologyTargetSelection: !isLicensing,
            headTargetSelection: !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.anatomyTargetSelection = true;
                featureAccess.biologyTargetSelection = true;
                featureAccess.headTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEThiemeTargets);

export const OEThiemeStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEThiemeTargets,
    OEThiemeStartSelectionContent
);